import { createSlice } from "@reduxjs/toolkit";

const checkSlice = createSlice({
  name: "check",
  initialState: { value: "nothing" },
  reducers: {
    check(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: () => {},
});

export { checkSlice };
export const { check } = checkSlice.actions;
